export const updateHeight = (ref: React.RefObject<HTMLDivElement>, isOpen: boolean): void => {
    const contentElement = ref.current

    if (contentElement) {
        contentElement.style.height = isOpen ? `${contentElement.scrollHeight}px` : '0'
    }
}
